const CustomResourceApplyBMX = () => import('@/views/main/report/customResourceApply/CustomResourceApplyBMX.vue')
export default {
  path: '/main/report/customResourceApplyBMX',
  name: 'customResourceApplyBMX',
  component: CustomResourceApplyBMX,
  children: []
}
